import { NotFoundPage } from "@humanex/ui/components";
import { Outlet, createRootRoute, useRouterState } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => NotFoundPage({ homeHref: "/" })
});

function Root() {
  const location = useRouterState({ select: (s) => s.location.pathname });

  // Public routes that bypass the admin layout
  const publicRoutes = ["/unauthorized"];
  if (publicRoutes.includes(location)) {
    return <Outlet />;
  }

  return (
    <div className="relative min-h-screen max-w-screen">
      <div className="bg-primary-50 fixed inset-0 z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
    </div>
  );
}
